const CLASSES = {
  default: "brh-composition-restaurant",
  get main() {
    return `.${CLASSES.default}`;
  },
  layout: {
    twoBlocks: ".two-blocks",
    oneBlockSmall: ".one-block-small",
    oneBlockBig: ".one-block-big",
  },
};

export default CLASSES;
